import styled from "styled-components";
import { motion } from "framer-motion";

export const MainStyled = styled(motion.main)`
  color: white;
`;
